import React from "react";
import logo from "../assets/otherimages/logobd.png"; // make sure logo.png exists in src/assets

const LoadingScreen = () => {
  return (
    <div className="fixed inset-0 flex items-center justify-center bg-white z-50">
      {/* Logo with pulse animation */}
      <img
        src={logo}
        alt="Logo"
        className="w-[10rem] h-[10rem] animate-pulse object-contain"
        loading="lazy"
      />
    </div>
  );
};

export default LoadingScreen;
